class SearchBar extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: 'open' });
    shadow.innerHTML = `
      <style>
        .wrapper-container {
          position: relative;
          font-family: sans-serif;
        }
        .wrapper {
          display: flex;
          align-items: center;
          position: relative;
        }
        input[type="text"] {
          flex: 1;
          padding: 4px 30px 4px 8px;
          font-size: 1em;
        }
        button {
          position: absolute;
          right: 5px;
          top: 5px;
          background: none;
          border: none;
          cursor: pointer;
          font-size: 1em;
        }
        ul.dropdown {
          position: absolute;
          top: 100%;
          left: 0;
          right: 0;
          border: 1px solid #ccc;
          max-height: 150px;
          overflow-y: auto;
          background: white;
          z-index: 10;
          margin: 0;
          padding: 0;
          list-style: none;
        }
        ul.dropdown li {
          padding: 8px;
          cursor: pointer;
        }
        ul.dropdown li:hover {
          background: #eee;
        }
        .spinner-overlay {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
        .spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(0, 0, 0, 0.1);
          border-left-color: black;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
      <div class="wrapper-container">
        <div class="wrapper">
          <input type="text" />
          <button>&#128269;</button>
        </div>
        <div class="spinner-overlay" style="display:none;"><div class="spinner"></div></div>
        <ul class="dropdown" style="display: none;"></ul>
      </div>
      <input type="hidden" class="hidden-value" />
    `;

    this.input = shadow.querySelector('input[type="text"]');
    this.button = shadow.querySelector('button');
    this.dropdown = shadow.querySelector('ul.dropdown');
    this.hidden = shadow.querySelector('.hidden-value');
    this.spinnerOverlay = shadow.querySelector('.spinner-overlay');

    this.button.addEventListener('click', () => this.doSearch());

    this.input.addEventListener('input', () => {
      if (this.config?.fetchOnInput && typeof this.config.fetchResults === 'function') {
        this.doSearch();
      }
      this.dispatchEvent(new CustomEvent('change', { detail: this.input.value }));
    });
  }

  configure(config) {
    this.config = config;
    this.input.placeholder = config.placeholder || '';
    this.hidden.name = this.getAttribute('name') || 'searchValue';
  }

  async doSearch() {
    const query = this.input.value;
    if (!this.config?.fetchResults) return;

    this.spinnerOverlay.style.display = 'block';
    const results = await this.config.fetchResults(query);
    this.spinnerOverlay.style.display = 'none';

    this.dropdown.innerHTML = '';
    if (results.length === 0) {
      this.dropdown.style.display = 'none';
      return;
    }

    results.forEach(item => {
      const li = document.createElement('li');
      li.textContent = item.text;
      li.addEventListener('click', () => {
        this.input.value = item.text;
        this.hidden.value = item.value;
        this.dropdown.style.display = 'none';
        this.dispatchEvent(new CustomEvent('change', { detail: item.value }));
      });
      this.dropdown.appendChild(li);
    });

    this.dropdown.style.display = 'block';
    if (typeof this.config.onSearch === 'function') {
      this.config.onSearch(query);
    }
  }
}
customElements.define('search-bar', SearchBar);